import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'
import { supplierGroupsQueryOptions } from '../../../features/suppliers/queries'
import { NewSupplierPage } from '../../../features/suppliers/supplier-edit-pages'

export const Route = createFileRoute('/_app/suppliers/new')({
  staticData: { crumb: 'supplierNew' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'suppliers.create'),
  loader: ({ context }) => {
    // Warm the group picker; the form does not wait for it.
    void context.queryClient.prefetchQuery(supplierGroupsQueryOptions)
  },
  component: NewSupplierPage,
})
